import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="faq"
export default class extends Controller {
  static targets = ["answer"];

  connect() {
    this.active = false;
  }

  toggleAnswer() {
    this.active = !this.active;
    this.element.dataset.active = this.active;
    this.answerTarget.classList.toggle("hidden");
  }
}
